import React, { useEffect } from 'react'
import { useUserDetails } from 'utils/hooks'

/**
 * This DeletionSuccessStep component exists so the browser can navigate to a dedicated xxx/DeletionSuccessStep url
 * that hosts it, and the mobile app that listens for url changes can close the webview and navigate accordingly.
 * The redirection in this component is mean for flows within a browser instance of Rogers.
 * This way we can just call logout, perform any browser specif things, without
 * affecting the app.
 * */
const DeletionSuccessStep = () => {
  const { logout } = useUserDetails()
  useEffect(() => {
    logout({ origin: 'fms', reason: 'accountDeletion' })
  }, [logout])
  return <></>
}

export default DeletionSuccessStep
